import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const CoupanEdit = () => {
  const { id } = useParams(); // Get Coupan ID from URL
  const navigate = useNavigate();

  const initialFormState = {
    coupon_name: "",
    coupon_code: "",
    description: "",
    apply_coupon_on: "order",
    discount_type: "price",
    discount_value: "",
    minimum_order_value: "",
    start_date: "",
    expiry_date: "",
    status: "active",
  };


  const [CoupanUser, setCoupanUser] = useState(initialFormState);

  useEffect(() => {
    const fetchCouponData = async () => {
      try {
        const res = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_new_coupon",
          { coupon_id: id },
          { headers: { "Content-Type": "application/json" } }
        );

        if (res.data?.success === "1") {
          setCoupanUser(res.data.data);
        } else {
          toast.error(res.data?.message || "Failed to load coupon");
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong while fetching coupon");
      }
    };

    fetchCouponData();
  }, [id]);
  

  const handleInput = (e) => {
    const { name, value } = e.target;
    setCoupanUser({ ...CoupanUser, [name]: value });
  };


  const submitForm = async (e) => {
    e.preventDefault();

    if (!CoupanUser.coupon_name || !CoupanUser.coupon_code) {
      toast.error("Coupon name and code are required");
      return;
    }

    const payload = {
      coupon_id: id,
      coupon_name: CoupanUser.coupon_name,
      coupon_code: CoupanUser.coupon_code,
      description: CoupanUser.description,
      apply_coupon_on: CoupanUser.apply_coupon_on,
      discount_type: CoupanUser.discount_type,
      discount_value: CoupanUser.discount_value,
      minimum_order_value: CoupanUser.minimum_order_value,
      start_date: CoupanUser.start_date,
      expiry_date: CoupanUser.expiry_date,
      status: CoupanUser.status,
    };

    try {
      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_new_coupon",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data?.success === "1") {
        toast.success("Coupon updated successfully");
        navigate("/Coupon-list");
      } else {
        toast.error(res.data?.message || "Update failed");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while updating coupon");
    }
  };


  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Edit Coupan</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Coupan</a>
                </li>
                <li className="breadcrumb-item active">Edit Coupan</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-9 col-lg-8 ">
            <form onSubmit={submitForm}>
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">General Information</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Product Name</label>
                        <input
                          type="text"
                          name="coupon_name"
                          value={CoupanUser.coupon_name}
                          onChange={handleInput}
                          className="form-control"
                        />

                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Product Type</label>
                      <input
                        type="text"
                        name="category"
                        value={CoupanUser.category}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter Product Type"
                      />
                    </div>

                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Price</label>
                        <input
                          type="number"
                          name="price"
                          value={CoupanUser.price}
                          onChange={handleInput}
                          className="form-control"
                          placeholder="Enter Price"
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Stock</label>
                        <input
                          type="number"
                          name="stock"
                          value={CoupanUser.stock}
                          onChange={handleInput}
                          className="form-control"
                          placeholder="Enter Stock Quantity"
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <select
                        name="status"
                        value={CoupanUser.status}
                        onChange={handleInput}
                        className="form-control"
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3 bg-light mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button
                      type="submit"
                      className="btn btn-outline-secondary w-100"
                    >
                      Update Coupan
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/Coupan-list" className="btn btn-primary w-100">
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CoupanEdit;
